import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { first, map } from 'rxjs/operators';

import {
  attachmentsClear,
  attachmentsGetLatestResume,
  getAttachmentsResumes,
} from '@collections/attachments';
import { Attachment, CandidateAdapter } from '@shared/models';
import { isTruthy } from '@shared/utils';

@Component({
  selector: 'mojo-candidate-resume-link',
  templateUrl: './resume-link.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResumeLinkComponent {
  @Input()
  candidate: CandidateAdapter;

  constructor(private store: Store<{}>) {}

  downloadResume() {
    this.dispatchDownloadAction();
    this.store
      .pipe(
        select(getAttachmentsResumes, {
          candidateId: this.candidate.id,
        }),
        map((attachments: Attachment[]) => !!attachments && [...attachments].shift()),
        first(isTruthy),
      )
      .subscribe((attachment: Attachment) => {
        const link = document.createElement('a');
        link.setAttribute('target', '_blank');
        link.setAttribute('href', attachment.path);
        link.setAttribute('download', attachment.name);
        document.body.appendChild(link);
        link.click();
        link.remove();
        this.store.dispatch(attachmentsClear());
      });
  }

  private dispatchDownloadAction() {
    this.store.dispatch(
      attachmentsGetLatestResume({
        payload: {
          candidateId: this.candidate.id,
          onlyPdfFiles: false,
        },
      }),
    );
  }
}
